import moment from "moment/moment";
import {DateFormats} from "../../constants/securspace-constants";
import {Response, SuperAgentRequest} from "superagent";
import request from "../../../util/SuperagentUtils";
import {supplierPayoutReportEndpoints} from "../../../requests/api-endpoints";
import {PayoutsFilterParams, PayoutsRequestParams} from "../../../types/payouts";

type PayoutsSearchParams = Partial<PayoutsRequestParams>;

const getPayoutsUrlParams = (requestParams: PayoutsSearchParams, isPageable: boolean): URLSearchParams => {

    const params = isPageable ? new URLSearchParams([["page", String(requestParams?.page || 0)], ["size", String(requestParams?.pageSize || 10)]]) : new URLSearchParams();

    if (requestParams?.startDate) {
        params.append("startDate", moment(requestParams?.startDate).format(DateFormats.DAY));
    }
    if (requestParams?.endDate) {
        params.append("endDate", moment(requestParams?.endDate).format(DateFormats.DAY));
    }
    if (requestParams?.locationId) {
        params.append("locationId", requestParams?.locationId)
    }
    if (requestParams?.status) {
        params.append("status", requestParams?.status)
    }
    if (requestParams?.payoutCompleted) {
        params.append("payoutCompleted", (requestParams?.payoutCompleted == 'true') ? 'true' : 'false')
    }
    if (requestParams?.sortBy) {
        params.append("sortBy", requestParams?.sortBy)
    }
    if (requestParams?.sortDir) {
        params.append("sortDir", requestParams?.sortDir)
    }

    return params;
}

export function requestPayoutsPaginated(
    searchParams: PayoutsSearchParams,
    onSuccess: (response: Response) => void,
    onFail: (error: unknown) => void
): void;
export function requestPayoutsPaginated(searchParams: PayoutsSearchParams): SuperAgentRequest;
export function requestPayoutsPaginated(
    searchParams: PayoutsSearchParams,
    onSuccess?: (response: Response) => void,
    onFail?: (error: unknown) => void
): void | SuperAgentRequest {

    const result = request.get(`${supplierPayoutReportEndpoints.search}?${getPayoutsUrlParams(searchParams, true)}`);

    if(onSuccess && onFail) {
        result
            .then(onSuccess)
            .catch(onFail)
    } else {
        return result
    }
}

export const getPayoutsReportUrl = (searchParams: PayoutsSearchParams): string => {
    return `${supplierPayoutReportEndpoints.report}?${getPayoutsUrlParams(searchParams, false)}`;
}

export const getPayoutsGroupSummaryUrl = (searchParams: PayoutsSearchParams): string => {
    const summaryParams: Partial<PayoutsFilterParams> = {
        startDate: searchParams.startDate,
        endDate: searchParams.endDate,
        locationId: searchParams.locationId
    }

    return `${supplierPayoutReportEndpoints.group}?${getPayoutsUrlParams(summaryParams, false)}`;
}

export const requestCalculatePayoutsSummary = async (searchParams: PayoutsSearchParams): Promise<Response> => {
    return await request.get(`${supplierPayoutReportEndpoints.summary}?${getPayoutsUrlParams(searchParams, false)}`);
}
